<template>
  <a href="javascript:void(0);" @click="openRatingReviewsModal()"> {{ ratings_received }} {{ ratings_received > 1 ? "avaliações" : "avaliação" }} </a>
</template>

<script>
import ratingsReceived from "./modals/ratings-received.vue";

export default {
  props: {
    fk_property: {
      type: Number,
      required: false,
    },
    fk_roommate: {
      type: Number,
      required: false,
    },
    ratings_received: {
      type: Number,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  methods: {
    openRatingReviewsModal() {
      if (typeof window.user_id === typeof undefined) {
        return EventBus.$emit('open-modal', 'login-modal');
      }

      if (this.ratings_received > 0) {
        axios.get(this.getUrl()).then(({ data }) => {
          EventBus.$emit('open-modal', ratingsReceived, {
            user: this.user,
            ratings: data,
          });
        });
      }
    },
    getUrl() {
      if (this.fk_property) {
        return `/property/property-ratings/${this.fk_property}`;
      } else if (this.fk_roommate) {
        return `/roommate/roommate-ratings/${this.fk_roommate}`;
      }
    }
  },
};
</script>
